import React, { useState, useEffect } from "react";
import { Field, useFormik } from "formik";
import { Button, Grid, Stack } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import axios from 'axios';
import * as Yup from 'yup';
import Cookies from 'js-cookie';
import RowadLogo from '../../RowadLogo';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import LoadingButton from "@mui/lab/LoadingButton";

const SignIn = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [LoadingAPI, setLoadingAPI] = useState(false);

  const onSubmit = (values) => {
    setLoadingAPI(true);
    axios.post(`${process.env.REACT_APP_Back_URL}/userst/authenticate`, {
      "email": values.email,
      "password": values.password,
      "token":values.email
    }).then((resp) => {
      if(resp.status ===200){
        if(resp.data.icon ==='success'){
        Cookies.set('token',(resp.data?.token || ""),{ expires: 365 })
        Swal.fire({
          icon: resp.data.icon,
          title: resp.data.message,
          showConfirmButton: false,
          timer: 1500
        }).then(()=>setTimeout( ()=>{navigate('/')},200) )
        }
        else{

          Swal.fire({
            icon: resp.data.icon,
            title: resp.data.message,
        
          })
          setLoadingAPI(false)

        }
  
      
 
      }
    });
  };

  const validationSchema = Yup.object().shape({
    token: Yup.string()
    .required("Captcha is Required"),
    password: Yup.string()
      .required("Password is Required"),
      // .matches(/^(?=.*[0-9])(?=.*[a-zA-Z]{3,})[a-zA-Z0-9_]+$/, 'Only English letters, at least 4 letters, and at least 1 number.')
      // .min(5, "Too Short")
      // .max(20, "Too Long"),
    email: Yup.string().required('Email is Required').matches(
      /^[a-zA-Z0-9._%+-]+@(rowad-rme|rme-fitout|rme-g|driller-eg|rowad-rme\.net|g-buildings|rowad-investment|tetraes|orascom)\.(com|net)$/,
      "Invalid Email must be from an authorized domain"
    )
  });

  const initialValues = {
    email: "",
    password: "",
    RememberMe: false,
    token:''
  };
  useEffect(() => {
   navigate('/sign-in')
    if (isValidGUID(id) && id) {
      axios.patch(`${process.env.REACT_APP_Back_URL}/userst/status`, {
        "statecode": 0,
        "statuscode": 1,
        id
      }).then(resp => {
        if (resp.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Account Activitated',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            Cookies.remove('token')
            setTimeout(() => {
              navigate('/new-ticket');
            }, 1500);
          });
        }
      }).catch(error => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });
      });
    }
  }, []);

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema
  });

  function isValidGUID(str) {
    let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);
    if (str == null) {
        return false;
    }
    if (regex.test(str)) {
        return true;
    } else {
        return false;
    }
  }

  return (
    <div className="container">
      <div className="signin-box">
        <RowadLogo />
        <h2>Sign In</h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              name="email"
              {...formik.getFieldProps('email')}
              required
            />
            {formik.errors.email && formik.touched.email ? <div className='error'>{formik.errors.email}</div> : null}
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              {...formik.getFieldProps('password')}
            />
            {formik.errors.password && formik.touched.password ? <div className='error'>{formik.errors.password}</div> : null}
          </div>
 
          <Link
            style={{ paddingBottom: "10px" }}
            // onClick={handleForgotPasswordClick}
            to="/reset-password"
          >
            Forgot Password
          </Link>

 
                           <div className="input-group">
 
                      <HCaptcha
                       
                        sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                        onVerify={(token) => {
                          formik.setFieldValue("token", token);
                          formik.setSubmitting(false);
                        }}
                        onExpire={() => {
                          formik.setFieldValue("token", "");
                        }}
                      />
 

                    {formik.errors.token && formik.touched.token ? <div className='error'>{formik.errors.token}</div> : null}
                </div>
          <Stack spacing={2}>
          <LoadingButton variant="contained"
                    loading={LoadingAPI}
                    type="submit"
                    color="success"
                  >
                  Login
                </LoadingButton>
            <hr />
            <Button variant="outlined" onClick={() => navigate("/sign-up")}>
              Create Account
            </Button>
          </Stack>
        </form>
      </div>
    </div>
  );
};

export default SignIn;